import {
  colorTypes,
  iconTypes,
  //assessmentEntries,
  phaseStatusList,
  scenarioConstraintIDs,
  conditionalConstraints,
  globalConstraints,
  M2CA_PhaseIE,
  SC8CP_PhaseIE,
  B4CA_PhaseIE,
  B5CA_PhaseIE,
  C5CA_PhaseIE,
  fbTemplatesDef,
  vitalsCheckFeedbackLabel,
  vitalsCheckFeedbackID
} from "@meddbriefer/feedback-data";


//import {  requiredPhaseNames } from "./analyzeEvents";
// constraintsViolated,
// import { c2FB } from "./summarizeAnalysis";
import { formatAsMinSecs } from "./utils";
//import { itemByID } from './analyzeEvents'
import { ANALYSIS_TYPES } from '@meddbriefer/scenario-data';
import { groupByKey } from './scenarioDataAccesors';


const _ = require("lodash");
let recreate = false;  //a true setting will cause the observer log to be recreated from the analysis log whenever a save is done during review.  The recreated
                       //log is saved in the recreatedLog collection
let gradingReport = false;  //a true setting will true the analysis log into a format that may be better for human grading/analysis




const C2_FIELDS = ["feedbackAbsent", "feedbackOutOfOrder", "feedbackErrors"];

export //for debug only of summarizeAnalysis
const scenarios = {
  //M2CA: M2CA_PhaseIE,
  SC8CP: SC8CP_PhaseIE,
  B5CA: B5CA_PhaseIE,
  B4CA: B4CA_PhaseIE,
  C5CA: C5CA_PhaseIE,
};


export const pushNew = (elt, array) => {
  if (!array.includes(elt)) {
    array.push(elt);
  }
};

export const intersects = (arr1, arr2) => {
    let result = arr1.filter(x => arr2.indexOf(x) !== -1);
    if (result.length > 0){
      return true
    }
    else {return false}
}


// Not yet tested.  May not need these two
/* export const intersection = (array1, array2) => {
    return array1.filter(value => array2.includes(value))
}

export const difference = (array1, array2) => {
    return array1.filter(value => !array2.includes(value))
}
 */

export function trimActions(actions,fields){
  let newActions = []
  actions.forEach (act => {
      newActions.push(trimAction(act,fields))
  })
  return newActions}


export function trimAction(event, fields) {

  let newEvent = {}
  //regularize some field names across headers and checklist events
  if (!!event.labelID) {
       newEvent.id = event.labelID}
  else { newEvent.id = event.id }

  //now copy over these fields
  fields.forEach(fld => {
      if (!!event[fld]) {
          newEvent[fld] = event[fld]}
  })
  return newEvent
}

export const getPhaseStatus = (statuses) => {
  //for collecting first unique item statuses and then
  //unique phase statuses
  let itemStatuses = [];
  let phaseStatuses = [];
  if (statuses.length === 0) {
    return "absent";
  }

  //get a unique list of item status values
  statuses.forEach((status) => {
    if (status !== "notFound"){
      pushNew(status, itemStatuses);
    }
    /* if (!itemStatuses.includes(status)){
            itemStatuses.push(status)
        } */
  });

  //turn the item status values into phase level status values
  let res;
  for (const [key, val] of Object.entries(phaseStatusList)) {
    res = val.filter((value) => itemStatuses.includes(value));
    //if there is an intersection, save the key (i.e. is unique)
    if (res.length !== 0) pushNew(key, phaseStatuses);
    /* if (!phaseStatuses.includes(key)){
                phaseStatuses.push(key)} */
  }

  if (phaseStatuses.length === 1) {
    if (phaseStatuses[0] === "error"){
      return "errors"}
    else {
      return phaseStatuses[0];}
  } // to be absent or good, all entries must be that value
  else {
    if (phaseStatuses.length === 2 && phaseStatuses.includes("good") && intersects(phaseStatuses, ["misordered", "misOrdered"])){
      return "misordered"
    }
    else {
      if (intersects(phaseStatuses, ["misordered", "misOrdered", "misorderedErrors", "misorderedError", "misOrderedError"]) && intersects(phaseStatuses, ["error", "errors", "absent"])){
        return "misorderedErrors"
      }
      else {
        return "errors";}}
  } //otherwise they are not all good to that translates to errors
};

// functions that extract info from above or create the feedback from the above

//returns a list of all the state values associated with the input status (e.g. status is one of "Problem", "Good", "Caution")
export const getStatesForStatus = (status, fbTemplates) => {
  let stateList = []
  for (const [state, entry] of Object.entries(fbTemplates)) {
    let stateStatus = entry[0]
    if (stateStatus === status) {
      stateList.push(state)
    }
  }
  return (stateList)
}


//returns the entry under that state
const getAssessmentEntry = (currentEntry, aIndex, fbTemplates) => {
  let assessmentEntry = "";
  if (currentEntry.type === "header") {
    assessmentEntry = fbTemplates[currentEntry.displayColor];
    if (!assessmentEntry) {
      assessmentEntry = fbTemplates[currentEntry.status];
    }
  } else {
    if (!fbTemplates[currentEntry.status]) {
      assessmentEntry = fbTemplates["default"];
    } else {
      assessmentEntry = fbTemplates[currentEntry.status];
    }
  }
  if (assessmentEntry) {
    return assessmentEntry[aIndex];
  }
};

//returns the html icon to use in condition 1 for the state
export const getAssessmentIcon = (currentEntry, fbTemplates) => {
  let val = iconTypes[getAssessmentEntry(currentEntry, 0, fbTemplates)];
  return val;
};

//returns the html color to use in condition 1 for the state
export const getColor = (currentEntry, fbTemplates) => {
    let color = colorTypes[getAssessmentEntry(currentEntry, 0, fbTemplates)]
    return color;}


//add protected spaces after a . except for the very last .
//Otherwise html reduces continguous regular spaces to a single space.
//Need this for text strings that will appear in one array entry because
//of substitution
const fixStrSp = (textString) => {
  if (!!textString) {
    let textArray = textString.split(" ");
    let lenTextArray = textArray.length;
    textArray.forEach((item, i) => {
      let newItem = item.trim()
      if (newItem[item.length - 1] === "." && i < lenTextArray - 1) {
        //add protected space to the string
        newItem = newItem + "\xa0\xa0"
      }
      textArray[i] = newItem
    })
    let newString
    for (let item of textArray) {
      if (!!newString) {
        newString = newString + " " + item;
      }
      else { newString = item }

    }
    return newString
  }
  else { return "" }
}

const generateIntvStatusFB = (currentEntry) => {
  let checked = [];
  let notChecked = [];
  let fb;
  for (let entry of currentEntry.intvStatus) {
    if (entry.foundCk) {
      checked.push(entry.label);
    } else {
      notChecked.push(entry.label);
    }
  }
  if (notChecked.length > 0) {
    fb = "Remember to check the effect of this action by asking for: " + notChecked + ".";
    if (checked.length > 0) {
      fb =fb + " That is in addition to what you did ask for: " + checked + ".";
    }
  }
  return fb
}

let fbSource = "json"  //values are "db" or "json"

function getFBField(currentEntry, field, c2FB) {
  let tailoredFB = ""
  let genFB = ""
  let combinedResult = ""
  let indexLabel
  if (currentEntry.variant){
    indexLabel = currentEntry.id //+ "-" + currentEntry.variant  //condition 2 fb has no variants
  }
  else {indexLabel = currentEntry.id}
  let fb = c2FB[indexLabel]
  let status = currentEntry.status
  switch (fbSource) {
    case "json":  //removed case value "db" in code below
      switch (field) {
        case "assessmentFB":  //get from c2 ds field feedbackAbsent
          if (fb && fb.feedbackAbsent && fb.feedbackAbsent[0] !== "") { tailoredFB = fb.feedbackAbsent }
          break
        case "why":
          if (fb && ["not indicated"].includes(status) && fb.feedbackErrors && fb.feedbackErrors[0] !== "") {
            tailoredFB = fb.feedbackErrors
          }
          if (fb && !["not indicated"].includes(status) && fb.feedbackAbsent && fb.feedbackAbsent[0] !== "") {
            tailoredFB = fb.feedbackAbsent
          }
          break
        case "incorrectAnswersFB":  //get from c2 ds field feedbackErrors
          if (fb && fb.feedbackErrors && fb.feedbackErrors[0] !== "") {
            genFB = fixStrSp(currentEntry[field]) + ".\xa0\xa0"
            tailoredFB = fb.feedbackErrors }
          break
        case "orderingFB":
          if (fb && fb.feedbackOutOfOrder && fb.feedbackOutOfOrder[0] !== "") {
            tailoredFB = fb.feedbackOutOfOrder }
          break
        default:
          genFB = fixStrSp(currentEntry[field]) + ".\xa0\xa0"
          break
      }
      break
    default:
  }
  if (!!tailoredFB && Array.isArray(tailoredFB)){
    tailoredFB.forEach ((para,i) => {
      //use below commented out block instead if want to preserve breaks put in condition 2 feedback
      /* if (i < tailoredFB.length-1){
        combinedResult = combinedResult + para + "</p>"}
      else {combinedResult = combinedResult + para} */
      if (combinedResult !== ""){
       combinedResult = combinedResult + "\xa0\xa0" + para}
      else {combinedResult = para}
    })
    combinedResult = genFB + combinedResult
  }
  //to deal with old analysis/feedback file from before c2FB feedback fields became an array of strings instead of a string
  else {
    if (!!tailoredFB){
      combinedResult = genFB + tailoredFB}
  }
  if (!combinedResult && !!currentEntry[field]) { combinedResult = fixStrSp(currentEntry[field]) }
  return combinedResult
}

export const getPhaseFeedback = (entry, phaseFBGiven, c2FB) => {

    let result = ""
    let fb
    let indexLabel
    if (!!entry.phFeedback) {
      if (!phaseFBGiven[entry.labelID]) {
        phaseFBGiven[entry.labelID] = true
        if (entry.variant){
          indexLabel = entry.labelID //+ "-" + variant  //commented out cause condition 2 feedback doesn't have variants
        }
        else {indexLabel = entry.labelID}
        fb = c2FB[indexLabel]
        if (fb && fb.feedbackOutOfOrder){
          result = fb.feedbackOutOfOrder }
        else {result = entry.phFeedback}
        if (fb && fb.feedbackOutOfOrder && fb.feedbackOutOfOrder !== "") {
          result = fb.feedbackOutOfOrder }
        else {result = entry.phFeedback}
      }
      else {
        result = entry.phFeedback
      }
    }
    if (entry.label === vitalsCheckFeedbackLabel){
      result = result + entry.vitalsFB
    }

    entry.phFeedback = result
    return [result, phaseFBGiven]

}

export const applyFBTemplate = (rep, c2FB, template) => {
  let fb;
  //Find any @ actions in the template and substitute with the indicated entry field
  let feedbackArray = template.split(" ");
  //Process all @ substitutions first since +eos does one forward action
  feedbackArray.forEach((item, i) => {
    let firstChar = item.charAt(0);
    let newString = item.substring(1);
    //trim off excess blanks before and after each word
    feedbackArray[i] = feedbackArray[i].trim();
    switch (firstChar) {
      case "@":
        fb = getFBField(rep, newString, c2FB);
        if (!!fb) {
          feedbackArray[i] = fb;
        } else {
          feedbackArray[i] = "[missing: " + newString + "]";
        }
        break;
      case "?":
        fb = getFBField(rep, newString, c2FB);
        if (!!fb) {
          //replace eos spacing with protected spaces in the substitution string
          feedbackArray[i] = fb;
        } else {
          feedbackArray[i] = ""
          if (feedbackArray[i - 1] === "+bos") {
            feedbackArray[i - 1] = "";
            if (!!feedbackArray[i - 2] && feedbackArray[i - 2][0] !== "+"){  //don't want to alter a command that has not been processed
              if (feedbackArray[i - 2][feedbackArray[i - 2].length - 1] !== ".") {
                feedbackArray[i - 2] = feedbackArray[i - 2] + ".\xa0";
              }}
          }
          if (feedbackArray[i + 1] === "+eos") {
            feedbackArray[i + 1] = "";
          }
        }
        break;
      default:
    }
  });
  //Now address the + actions in the template
  feedbackArray.forEach((item, i) => {
    let firstChar = item.charAt(0);
    let previousString = "";
    let nextString
    switch (firstChar) {
      case "+":
        let afterPlusChar = item.substring(1);
        switch (afterPlusChar) {
          //marks error category.  Assumes it is the first part of the message
          case "bec":
            feedbackArray[i] = ""; //get rid of the command since was applied
            //Captitalize the beginning of the sentence
            nextString = feedbackArray[i + 1].trim();
            feedbackArray[i + 1] =
              "\<em\>" + nextString.charAt(0).toUpperCase() + nextString.slice(1);
            break;
          case "eec":
            feedbackArray[i] = ""; //get rid of the command since was applied
            previousString = feedbackArray[i - 1].trim();
            feedbackArray[i - 1] = previousString + "\</em\>.\xa0";
            break;
          case "eos":
            //removes existing/redundant "." if present so can be certain putting in single "."
            previousString = feedbackArray[i - 1].trim();
            if (previousString[previousString.length - 1] === ".") {
              previousString = previousString.slice(0, -1);
            }
            //now add end of sentence and a protected space.  When stiched back into
            //a single string a protected space will be added between each substring
            feedbackArray[i - 1] = previousString + ".\xa0";
            feedbackArray[i] = ""; //get rid of the command since was applied
            break;
          case "bos":
            //removes existing/redundant "." if present so can put in single "."
            previousString = feedbackArray[i - 1].trim();
            if (previousString !== ""){
              if (previousString[previousString.length - 1] === ".") {
                previousString = previousString.slice(0, -1);
              }
              //now add end of sentence .
              feedbackArray[i - 1] = previousString + ".\xa0";
            }
            feedbackArray[i] = ""; //get rid of the command since was applied
            //Captitalize the beginning of the sentence
            nextString = feedbackArray[i + 1].trim();
            feedbackArray[i + 1] =
              nextString.charAt(0).toUpperCase() + nextString.slice(1);
            break;
          default:
        }
        break;
      default:
    }
  });
  //stitch back into a single string
  let feedbackString = "";
  for (let item of feedbackArray) {
    if (!!feedbackString) {
      if (item !== "") {
        feedbackString = feedbackString + "\xa0" + item;
      }
    } else {
      if (item !== "") {
        feedbackString = item;
      }
    }
  }
  return feedbackString
}

export const getFeedback = (currentEntry, c2FB, fbTemplates) => {
  let vitalsCheckFB = ""
  let feedbackString = ""
  /* if (currentEntry.id === vitalsCheckFeedbackID){
    vitalsCheckFB = currentEntry.vitalsFB
  } */
  if (currentEntry.type !== "header"){
    if (!!currentEntry.intvStatus && currentEntry.intvStatus.length > 0) {
      //add our generated feedback string to the currentEntry
      currentEntry.intvStatusFB = generateIntvStatusFB(currentEntry);
    }
    let feedbackTemplate = fixStrSp(getAssessmentEntry(currentEntry, 1, fbTemplates)).trim();
    if (feedbackTemplate !== ""){
      feedbackString = applyFBTemplate(currentEntry, c2FB, feedbackTemplate)}
    //console.log(feedbackString)
    if (vitalsCheckFB !== ""){
      feedbackString = vitalsCheckFB + "</p>" + feedbackString}
    return feedbackString}
  //else {return vitalsCheckFB}
  };

export const filterConstraintsBySolutions = (expectedScenInterventions) => {
  scenarioConstraints = Object.assign(initialConstraints);
  for (const [key, val] of Object.entries(scenarioConstraints)) {
    if (val.type === "leafI" && !expectedScenInterventions.includes(key)) {
      delete scenarioConstraints[key];
    }
  }
}

//built by the function initializeConstraints
var initialConstraints = {};
var scenarioConstraints = {};
var AFTER_FIELDS = ["id", "before", "beforeOp", "type"]
// adds on scenario specific constraints where the constraint is only applicable if certain patient
// conditions hold.  Since assessment callouts are text and have no associated representation, we
// can yet implement true conditional constraints.
export const initializeConstraints = (scenarioName) => {
  initialConstraints = Object.assign(JSON.parse(JSON.stringify(globalConstraints)))
  // look up applicable conditional constraints from const structure scenarioConstraintIDs
  let constraintIDs = scenarioConstraintIDs[scenarioName];
  if (!!constraintIDs && constraintIDs.length !== 0) {
    for (const [key, val] of Object.entries(conditionalConstraints)) {
      if (constraintIDs.includes(val.id)) {
        initialConstraints[key] = val;
      }
    }
  }
  //rewrite the afters as before constraints
  for (const [arg1st, constraint] of Object.entries(initialConstraints)) {
      if ((constraint.after).length !== 0){
        let afters = constraint.after
        constraint.after = []
        initialConstraints[arg1st] = constraint
        afters.forEach(arg => {
          let argConstraint = {}
          if (initialConstraints[arg]){
            argConstraint = initialConstraints[arg]
          }
          else {  //I believe this is incorrect. Should only copy over id and type for brand new constraints and always set op to "and"
                  //I think just remove "before" and "beforeOp" from AFTER_FIELDS.  I would change it but I don't
                  //have time to set up a test for the change.  Only T7 constraint has both befores and afters and this error doesn't
                  //cause any inconsistencies for that particular constraint.  PWJ 8/30/23
            AFTER_FIELDS.forEach(fldName => {
              if (!!constraint[fldName]){
                argConstraint[fldName] = constraint[fldName]}})
          }
          argConstraint.before = (argConstraint.before).concat([arg1st])  //should probably make sure if more than one before that beforeOp is and
          initialConstraints[arg] = argConstraint
        })

    }}

};

//gets one constraint since each id/label would be a key
//in the constraints definitions
export const getConstraint = (item) => {
  let id = item.id;
  let label = item.label;
  let constraints = scenarioConstraints[id];
  if (!constraints) {
    constraints = scenarioConstraints[label];
  }
  return constraints;
};

// This section is for looking up items in the analysis log

export const getEvents = (events, field, val) => {
  return events.filter((entry) => entry[field] === val);
};

export const getEventsByIdTime = (events, id, timestamp) => {
  return getEvents(getEvents(events, "timestamp", timestamp), "id", id);
};

// This ends the section for looking up items in the analysis log






function storeLeafActions(actions, c2FB, requiredPhaseNames) {
  let result;
  let indexLabel;
  actions.forEach((action) => {
    result = requiredPhaseNames.includes(action.id);
    if (action.subActions.length === 0 || result) {
      let newAction = {};
      C2_FIELDS.forEach((fldName) => {
        if (!!action[fldName]) {
          newAction[fldName] = action[fldName];
        }
      });
      /* if (action.variant){
        indexLabel = action.id + "-" + action.variant}
      else {indexLabel = action.id} */
      indexLabel = action.id
      c2FB[indexLabel] = newAction;
      if (result) {
        storeLeafActions(action.subActions, c2FB, requiredPhaseNames);
      }
    }
    else {
      storeLeafActions(action.subActions, c2FB, requiredPhaseNames);
    }
  });
}



//changes with each scenario what data structure should be parsed
function buildC2FB(scenName, requiredPhaseNames) {
  let c2FB = {};
  // FIX ME: possible fix to call getScenarioFeedback(scenName) in feedback-data/mergeDataFiles.js
  // but wait until Scott has finished first implementation of condition 2
  let phaseIE = scenarios[scenName];
  if (!!phaseIE) {
    let top = phaseIE.Action;
    storeLeafActions(top.subActions, c2FB, requiredPhaseNames);
  }
  return c2FB
}


//This starts section for saving/loading the debriefing log

/* export const saveAnalysisLog = (db, log, actions, constraintsViolated) => {
  saveLog(db, "debriefing-feedback-logs", log, actions, constraintsViolated, label, "");
}; */


export const saveAnalysisLog = async (db, obsLog, analysisData, userName) => {
  const {events: actions, requiredPhaseNames} = analysisData

  let metaData = {
    "label": obsLog.label,
    "analyzer": userName,
    "observerLogID": obsLog.id,
    "classCode": obsLog.classCode || "",
    "condition": obsLog.condition || "",
    "scenarioID": obsLog.scenarioID,
    "scenarioName": obsLog.scenarioName,
    "FBfields": buildC2FB(obsLog.scenarioName, requiredPhaseNames),
    /* "constraintsViolated": constraintsViolated,
    "requiredPhaseNames": requiredPhaseNames,*/
    "feedbackTemplates": fbTemplatesDef,
    /* "promptIDs": promptIDs,
    "decisionPromptIDs": decisionPromptIDs,  */
    "timestamp": Date()
    }
  let data = {
    ...metaData,
    ...analysisData
  }

  //data["comments"] = Array(actions.length).fill("")
    if (!!actions) {
      let newActionsList = [];
      let newObj = {};
      let filterUnknown = false;
      //reporting included for debugging puposes only
      actions.forEach(function (logObj, index) {
        for (let [key, val] of Object.entries(logObj)) {
          if (undefined === val) {
            console.log("filtered out from events; index: ", index, " key: ", key, " value: ", val);
            filterUnknown = true;
          }
        }
      });
      //do the filtering of unknowns
      if (filterUnknown) {
        actions.forEach(function (logObj, index) {
          newObj = _.pickBy(logObj, function (value, key) {
            return !(value === undefined);
          });
          newActionsList.push(newObj);
        });
        data["events"] = newActionsList;
      }
      else {data["events"] = actions;}
    }
  //window.alert(`analyzed-log/${data.label} created`);
  //console.log("about to save data", data)
  const dataWithID = await saveLog(db, "analyzed-logs", undefined, data)
  //window.alert(`analyzed-log/${data.label} created`);
  return dataWithID

}

const ITEM_FIELDS = [
  "abbrLabel",
    "depth",
    "graded",
    "parentID",
    "phase",
    "subPhase",
]

const OB_FIELDS = [
    "id",
    "label",
    "type",
    "finding",
    "vitalType",
    "vital",
    "value",
    "prompt",
    "promptID",
    "intvVariant",
    "patientStatus",
    "performedCorrectly",
    "timestamp"

  ];

const initializeItemLookupByID = (scenario) => {
    let checklistLookupByID = groupByKey(scenario._checkListMetaData.filter(e => ANALYSIS_TYPES.includes(e.type)), "id")
    let intvLookupByID
    if (!!scenario._interventions) {
        intvLookupByID = groupByKey(scenario._interventions, "id")
    }
    else { intvLookupByID = groupByKey(scenario.intvMetaData.filter(e => ANALYSIS_TYPES.includes(e.type)), "id") }
    let result = Object.assign(checklistLookupByID, intvLookupByID)
    return result
}

const initializeByAnswerLabel = (scenario) => {
  let result = groupByKey(scenario._interventionPromptAnswers, "label" || "abbrLabel")
  return result
}

const createObsLogFromAnalysisLog = async (db, scenario, anaLog, actions) => {
  let itemByID = initializeItemLookupByID(scenario)
  let byAnswerLabel = initializeByAnswerLabel(scenario)
  let data = {
    "label": anaLog.label || "",
    "userName": anaLog.analyzer || "",
    "classCode": anaLog.classCode || "",
    "condition": anaLog.condition || "",
    "scenarioName": anaLog.scenarioName || "",
    "timestamp": Date()
    }

  let newActions = []
  actions.forEach(function (logObj, index) {
    if (logObj.numericalID >= 1 && logObj.timestamp !== -1){
        let newObj = {}
        OB_FIELDS.forEach(fldName => {
            if (!!logObj[fldName] && logObj[fldName] !== undefined) {
                newObj[fldName] = logObj[fldName];
            }})
        let item = getItem(logObj.id, itemByID, [])
        if (item){
          ITEM_FIELDS.forEach(fldName => {
              if (!!item[fldName] && item[fldName] !== undefined) {
                  newObj[fldName] = item[fldName];
              }})}
        if (newObj.type === "intervention"){
          newObj.interventionID = newObj.id
        }
        if (!!logObj.answerDetails){
          let answers = {}
          for (const [key, value] of Object.entries(logObj.answerDetails)) {
            let answerID = byAnswerLabel[value.givenAnswer]
            if (!answerID){console.log("answerID not found for: ", value.givenAnswer)}
            else {answers[key] = [answerID[0].id]}
            }
          newObj.answers = answers
        }
        newActions.push(newObj)}})

  data["events"] = newActions

  console.log("saving recreated log: ", data)
  const dataWithID = await saveLog(db, "recreatedLogs", undefined, data)
  return dataWithID
  }


//log input needs to be an analysis log
export const saveGradingLog = async (db, log, actions) => {

  let data = {
    "label": log.label,
    "analyzer": log.analyzer || "",
    "classCode": log.classCode || "",
    "condition": log.condition || "",
    "scenarioName": log.scenarioName,
    "timestamp": Date()
    }

  actions.forEach(function (logObj, index) {
    if (logObj.numericalID >= 1){
      if (!data[logObj.id]){
        data[logObj.id] = logObj.status}
      else {for (let index = 1; index < 10; index++) {
        if (!data[logObj.id + index]){
          data[logObj.id + index] = logObj.status
          break}
        }}


      }})


  //console.log("about to save data", data)
  const dataWithID = await saveLog(db, "grading-logs", undefined, data)
  //window.alert(`analyzed-log/${data.label} created`);
  return dataWithID

}

export const saveCommentLog = async (db, scenario, priorLog, id, comments, userName) => {
  let data =
      {
        label: priorLog.label || null,
        reviewer: userName,
        analysisLogID: priorLog.id,
        scenarioID: priorLog.scenarioID,
        scenarioName: priorLog.scenarioName,
        classCode: priorLog.classCode || "",
        condition: priorLog.condition || "",
        comments: comments,
        timestamp: Date(),
      };

    if (recreate){createObsLogFromAnalysisLog(db, scenario, priorLog, priorLog["events"])}
    if (gradingReport) {saveGradingLog(db, priorLog, priorLog["events"])}
    await saveLog(db, "cond1-comments", id, data);
    //window.alert(`cond1-comments/${priorLog.label} saved`);
    // return savedData
};

// export const saveAsCommentLog = (db, priorLog, comments, userName) => {
//   let filename = window.prompt("Enter new filename", priorLog.label);
//   let data =
//       {
//         label: filename || null,
//         commenter: userName,
//         analysisLogID: analysisLogID || null,
//         comments: comments || null,
//         timestamp: Date(),
//       };
//     let savedData = saveLog(db, "cond1-comments", data);
//     window.alert(`cond1-comments/${filename} saved`);
//     return savedData;
// };

export async function saveLog (db, collection, id, data) {
  //console.log("In saveLog")
  var docRef
  if (!!id){
    docRef = db.collection(collection).doc(id);}
  else {
    docRef = db.collection(collection).doc();
    data.id = docRef.id;
  }
  await docRef.set(data);
  return data
};

//not in use

/* export const retrieveDebriefing = (log) => {
  //console.log(log.events)
  return log.events;
} */

//This ends section for saving/loading the debriefing log

export const getTimestamp = (currentEntry) => {
  if (!currentEntry.timestamp || currentEntry.type === "header") {
    return "";
  }
  if (currentEntry.timestamp === -1) {
    return "\xa0\xa0"; // formatAsMinSecs would convert this to 59:59
  }
  return formatAsMinSecs(currentEntry.timestamp);
}

let unknownItem = {id: "Unknown", label: "Unknown"}

const getItems = (val,itemByID,itemByLabel) => {
  if (val === "Unknown"){
      return unknownItem}
  let items = []
  items = itemByID[val]
  if (!items){
      items = itemByLabel[val]}
  return items
}

export const getItem = (val,itemByID,itemByLabel) => {
  let items = getItems(val,itemByID,itemByLabel)
  if (items){return items[0]}
}